import { FormattingOperator, FormattingRuleOperator } from '@ardoq/api-types';
import { t, type I18nLocale } from '@ardoq/i18n';

export const getConditionOptions = (
  i18nLocale: I18nLocale
): Array<{
  label: string;
  value: FormattingOperator;
}> => [
  {
    label: t(
      i18nLocale,
      'appLayout:viewPaneHeader.relativeDate',
      'Relative date'
    ),
    value: FormattingRuleOperator.RELATIVE_DATE,
  },
  {
    label: t(i18nLocale, 'appLayout:viewPaneHeader.isBetween', 'is between'),
    value: FormattingRuleOperator.DATE_BETWEEN,
  },
  {
    label: t(
      i18nLocale,
      'appLayout:viewPaneHeader.isOnOrBefore',
      'is on or before'
    ),
    value: FormattingRuleOperator.DATE_ON_OR_BEFORE,
  },
  {
    label: t(
      i18nLocale,
      'appLayout:viewPaneHeader.isOnOrAfter',
      'is on or after'
    ),
    value: FormattingRuleOperator.DATE_ON_OR_AFTER,
  },
];
